import jQuery from 'jquery';
let $ = jQuery;

import 'HSNDIR/Service.js';

HSN.Service.ProductService = function () {

};
HSN.Service.ProductService.prototype = {
    GetByIds: function (ids, config) {
        var url = '/api/products?' + $.param({ ids: ids }, true);
        this._get(url, {}, config);
    },

    GetCarousel: function (ids, data, config) {
        var url = '/dynamic-carousel?' + $.param({ ids: ids }, true);
        this._get(url, data, config);
    },

    _get: function (url, data, config) {
        config = (config = config || {});

        $.ajax({
            url: url,
            type: 'GET',
            data: data,
            context: this,
            dataType: config.dataType || 'json',
            success: function (responseData) {
                if (config.callback) {
                    config.callback.call((config.scope || config.callback), responseData);
                }
            },
            error: function (xhr, status) {
                if (config.errorCallback) {
                    config.errorCallback.call((config.scope || config.errorCallback), status);
                }
            }
        });
    }
};


// WEBPACK FOOTER //
// ./assets/js/HSN/Service/ProductService.js